<template>
  <div class="common-table">
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="headerStyle"
    >
      <el-table-column
        v-if="table.hasSelect"
        type="selection"
        width="55"
        align="center"
      ></el-table-column>
      <el-table-column type="index" width="60" label="序号" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + (current_page - 1) * per_page + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(column, index) in table.columns"
        :prop="column.prop"
        :key="index"
        :label="column.label"
        align="center"
        :width="index === 7 ? 150 : ''"
      >
      
        <template slot-scope="scope">
          <span v-if="column.type == 'resource'">
            {{
              scope.row.isAchievement	 === 1 && scope.row.isMarket === 1
                ? '双平台'
                : scope.row.isMarket === 1
                ? '大市场平台'
                : '成果交易平台'
            }}
          </span>
          <span v-if="column.type">
            <span
              v-if="column.type == 'status'"
            >
              <!-- @mouseover="mouseoverEvent(scope.row, scope.row[column.prop])" -->
              <el-tag type="info" v-show="scope.row[column.prop] == 0"
                >已申请</el-tag
              >
              <el-tag type="danger" v-show="scope.row[column.prop] == 1"
                >签订委托合同</el-tag
              >
              <el-tag type="success" v-show="scope.row[column.prop] == 2 || scope.row[column.prop] == 4"
                >准备材料</el-tag
              >
              <el-tag type="primary" v-show="scope.row[column.prop] == 6"
                >补充材料</el-tag
              >
              <el-tag type="danger" v-show="scope.row[column.prop] == 7 || scope.row[column.prop] == 5"
                >专家评审</el-tag
              >
              <el-tag type="success" v-show="scope.row[column.prop] == 8"
                >编写报告</el-tag
              >
              <el-tag type="success" v-show="scope.row[column.prop] == 9"
                >已完成</el-tag
              >
            </span>
          </span>
          
          <span
              v-if="column.type == 'zjrkAuditStatus'"
            >
              <el-tag type="warning" v-if="scope.row[column.prop] == 1 || scope.row[column.prop] == 2">审核中</el-tag>
              <el-tag type="success" v-else-if="scope.row[column.prop] == 3 ">已完成</el-tag>
              <el-tag type="primary" v-else-if="scope.row[column.prop] == 0">待审核</el-tag>
            </span>
            <span
              v-if="column.type == 'sex'"
            >
              <span  v-if="scope.row[column.prop] == 1">男</span>
              <span  v-else>女</span>
            </span>
          <span v-if="column.type == 'achievement_type'">
            {{ scope.row[column.prop] === 1 ? '应用类' : '基础类' }}
          </span>
          <div v-if="column.type == 'satisfaction'" @click="showRate(scope.row.id)" class="satisfaction_wrap">
            <el-rate v-model="scope.row[column.prop]" disabled v-if="scope.row[column.prop]"></el-rate>
          </div>
          <span v-if="!column.type">{{ scope.row[column.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="170"
        align="center"
        v-if="table.hasBtn2"
      >
        <template slot-scope="scope">
          <el-button
            size="small"
            :key="index"
            type="primary"
            v-if="scope.row['status'] == 0"
            @click="handleFun('acceptanceFun', scope.row)"
            >确认受理
            </el-button
          >
          <el-button
            size="small"
            type="warning"
            :key="index"
            v-if="scope.row['status'] == 1"
            @click="handleFun('editFun', scope.row)"
            >编辑</el-button
          >
          <el-button
            size="small"
            :key="index"
            type="success"
            @click="handleFun('detailsFun', scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="170"
        v-if="table.hasBtn"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            :type="item.type"
            size="small"
            v-for="(item, index) in table.btns"
            :key="index"
            @click="clickEvent(item, scope.row)"
            >{{ item.name }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div style="display: flex; justify-content: center">
      <el-pagination
        @current-change="handleCurrentChange"
        :hide-on-single-page="true"
        :current-page.sync="current_page"
        :page-size="per_page"
        layout="total, prev, pager, next"
        :total="total"
        prev-text="上一页"
        next-text="下一页"
        style="text-align: left; margin: 20px 0"
      ></el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  props: ["table", "url", "tableParams"],
  data() {
    return {
      current_page: 1,
      per_page: 10,
      total: 10,
      headerStyle: {
        color: "#623aa2",
        background: "#E5F3FE",
      },
      tableData: [],
      phoneType: ["电话", "手机号", "微信号"],
      params: {},
    };
  },

  methods: {
    seachFun() {
      this.getData(this.url)
    },
    showRate(id) {
      this.$emit("showRate", id)
    },
    clickEvent(item, row) {
      this.$emit(item.event, row);
    },
    handleFun(item, row) {
      this.$emit(item, row);
    },
    handleCurrentChange(val) {
      this.getData(this.url);
    },
    // 获取评价申请列表
    getData(val) {
      this.params.page=this.current_page
      this.params.pageSize=this.per_page
      this.http.post(val, this.params).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data.data;
          this.per_page = Number(res.data.per_page);
          this.total = res.data.total;
          this.current_page = res.data.current_page;
        } else {
          this.$message.error("获取数据失败！！");
        }
      });
    },
  },
  watch: {
    tableParams: {
      handler(val) {
        if (val) {
          console.log('val:', val)
          this.params = val
          if(val.status === "") {
            delete this.params.status
          }
          this.getData(this.url);
        }
      },
      immediate: true,
    },
    url: {
      handler(val) {
        if (val) {
          this.getData(val);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.el-rate{
  cursor: pointer
}
</style>
